(function () {
  'use strict';

  const angular = window.angular;

  ProfileController.$inject = [
    '$uibModal',
    '$state',
    '$timeout',
    'UserService',
    'Admin',
    'Manager',
    'SuperAdmin',
  ];

  angular.module('app').component('accountProfile', {
    template:'<div class="well well-light"><div ng-class="{transparent: ctrl.loading}" class="profile-content"><div class="profile-left"><div class="profile-left-fix"><div class="text-center thumbnail marginB10"><img ng-if="ctrl.user.image" ng-src="{{ctrl.user.image}}"> <img ng-if="!ctrl.user.image" ng-src="{{$root.assetsPath}}/images/no-image.png"></div><button class="btn btn-block btn-warning btn-smp" ng-click="ctrl.showImageModal()" translate>buttons.change</button></div></div><div class="profile-right"><div class="table-responsive"><table class="table table-borderless no-margin"><thead><tr><th colspan="2"><div class="pull-left"><h2 class="no-margin text-info">{{ctrl.user.name}} {{ctrl.user.surname}}</h2><h3 class="no-margin" style="display: block">@{{ctrl.user.username}}</h3></div><div class="btn-group btn-group-sm pull-right"><button class="btn txt-color-white btn-warning" ng-click="ctrl.showEditModal()"><i class="fas fa-edit"></i></button> <button ng-show="ctrl.telegramSessions.length" class="btn btn-telegram" ng-click="ctrl.showTelegramSessions()"><i class="fab fa-telegram-plane"></i></button> <button ng-if="ctrl.show2faEnableButton" ng-class="{\'btn-success\':ctrl.twoFactorActivated,\'btn-default\':!ctrl.twoFactorActivated}" class="btn txt-color-white" ng-attr-title="{{ ctrl.twoFactorActivated ? \'buttons.disable2fa\' : \'buttons.enable2fa\' | translate }}" ng-click="ctrl.show2faModal()"><i ng-class="ctrl.twoFactorActivated ? \'fas fa-lock\' : \'fas fa-unlock\'"></i></button> <button class="btn txt-color-white btn-primary" ng-click="ctrl.showPasswordModal()"><i class="fas fa-key"></i></button></div></th></tr><tr></tr></thead><tbody><tr class="separator"><td colspan="2"></td></tr><tr class="bordered"><td class="field" translate>entities._all.email</td><td>{{ctrl.user.email}}</td></tr><tr class="bordered"><td class="field" translate>entities._all.phone</td><td>{{ctrl.user.phone}}</td></tr><tr class="bordered"><td class="field" translate>entities._all.address</td><td>{{ctrl.user.address}}</td></tr><tr class="bordered"><td class="field" translate>entities._all.birthday</td><td>{{ctrl.user.birthday | date}}</td></tr><tr class="separator"><td colspan="2"></td></tr><tr><td class="field" translate>entities._all.country</td><td>{{ctrl.user.country.name}}</td></tr><tr><td class="field" translate>entities._all.timezone</td><td>{{ctrl.user.timezone.text}}</td></tr></tbody></table></div></div></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small\'"></spinner></div>',
    controller: ProfileController,
    controllerAs: 'ctrl',
    bindings: {
      countries: '<',
      timeZones: '<',
      user: '<',
    },
  });

  function ProfileController($uibModal, $state, $timeout, UserService, Admin, Manager, SuperAdmin) {
    let vm = this;

    vm.$onInit = function () {
      vm.loading = false;
      vm.user.birthday = vm.user.birthday ? new Date(vm.user.birthday) : null;

      if (vm.user.timeZoneId) {
        vm.user.timezone = vm.timeZones.find((timezone) => vm.user.timeZoneId === timezone.id);
      }

      if (vm.user.countryId) {
        vm.user.country = vm.countries.find((country) => vm.user.countryId === country.id);
      }

      vm.datepickerOps = {
        showWeeks: false,
      };

      vm.showEditModal = showEditModal;
      vm.showPasswordModal = showPasswordModal;
      vm.showImageModal = showImageModal;
      vm.show2faModal = show2faModal;
      vm.showTelegramSessions = showTelegramSessions;
      vm.show2faEnableButton = !window.disable2fa;
      vm.showImagePreview = false;
      vm.twoFactorActivated = false;
      if (vm.user.isSuperAdmin) {
        vm.Model = SuperAdmin;
      } else if (vm.user.isAdmin) {
        vm.Model = Admin;
      } else {
        vm.Model = Manager;
      }
      // check(vm.user.id);
      // checkTelegramActiveSessions(vm.user.id);
    };

    function checkTelegramActiveSessions(id) {
      vm.Model.prototype$getMiniAppUserSessionsActive({ id: id })
        .$promise.then((res) => {
          vm.telegramSessions = angular.copy(res);
        })
        .catch((err) => {
          vm.telegramSessions = [];
          console.log('err:', err);
        });
    }

    function check(id) {
      vm.Model.prototype$otpCheck({
        id: id,
      })
        .$promise.then((response) => {
          vm.twoFactorActivated = response.enabled;
          $timeout(function () {
            vm.loading = false;
          }, 300);
        })
        .catch((err) => {
          vm.loading = false;
        });
    }

    function show2faModal() {
      if (vm.twoFactorActivated) {
        $uibModal
          .open({
            animation: false,
            backdrop: 'static',
            bindToController: true,
            windowClass: 'modal-lg modal-warning',
            component: 'disableTwoFactorForm',
            size: 'mg',
            resolve: {
              user: () => vm.user,
              model: () => vm.Model,
            },
          })
          .result.then(function (result) {
            vm.twoFactorActivated = !result.success;
            $state.reload();
          })
          .catch(function (err) {
            console.log(err);
          });
      } else {
        $uibModal
          .open({
            animation: false,
            backdrop: 'static',
            windowClass: 'modal-event',
            bindToController: true,
            component: 'twoFactorForm',
            size: 'mg',
            resolve: {
              user: () => vm.user,
              model: () => vm.Model,
            },
          })
          .result.then(function (result) {
            vm.twoFactorActivated = result.success;
            $uibModal.open({
              animation: false,
              backdrop: 'static',
              bindToController: true,
              component: 'twoFactorFormSuccess',
              size: 'mg',
              resolve: {
                user: () => vm.user,
                model: () => vm.Model,
              },
            });
          })
          .catch(function (err) {
            console.log(err);
          });
      }
    }

    function showEditModal() {
      $uibModal
        .open({
          animation: false,
          backdrop: 'static',
          bindToController: true,
          component: 'accountProfileForm',
          size: 'lg',
          resolve: {
            user: () => vm.user,
            countries: () => vm.countries,
            timezones: () => vm.timeZones,
          },
        })
        .result.then(function (result) {
          $state.reload();
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function showPasswordModal() {
      $uibModal
        .open({
          animation: false,
          backdrop: 'static',
          bindToController: true,
          component: 'accountChangePassword',
          resolve: {
            user: () => vm.user,
          },
        })
        .result.then(function (result) {
          $state.reload();
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function showImageModal() {
      let model = UserService.getModel();
      let instance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        bindToController: true,
        component: 'accountProfileImage',
        resolve: {
          entityId: function () {
            return vm.user.id;
          },
          entity: function () {
            return model;
          },
          property: function () {
            return 'profile';
          },
        },
      });

      instance.result
        .then(function (result) {
          if (result.files && result.files.file && result.files.file.length) {
            let file = result.files.file[0];

            vm.user.container = vm.user.container || {};
            vm.user.container._profile = file;

            vm.user.image = UserService.getUserImageUrl(vm.user);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function showTelegramSessions() {
      let instance = $uibModal.open({
        animation: true,
        backdrop: 'static',
        bindToController: true,
        size: 'lg',
        component: 'telegramActiveSessions',
        resolve: {
          userId: function () {
            return vm.user.id;
          },
          sessions: function () {
            return vm.telegramSessions;
          },
          model: function () {
            return vm.Model;
          },
        },
      });

      instance.result
        .then(function (result) {
          $state.reload;
        })
        .catch((err) => {
          console.log('err', err);
        });
    }
  }
})();
